import { lazy } from 'react';

// project imports
import Loadable from 'ui-component/Loadable';
import MinimalLayout from 'layout/MinimalLayout';
// login option 3 routing
const AuthLogin3 = Loadable(lazy(() => import('views/authentication/authentication3/Login3')));
const ResetPasswordForm = Loadable(lazy(() => import('views/resetPassword/ResetPasswordForm')));
const ChangePasswordForm = Loadable(lazy(() => import('views/changePassword/changePasswordForm')));
const OtpVerification = Loadable(lazy(() => import('views/otpVerification/OtpVerification')));
// ==============================|| AUTHENTICATION ROUTING ||============================== //

const AuthenticationRoutes = {
    path: '/',
    element: <MinimalLayout />,
    children: [
        {
            path: '/login',
            element: <AuthLogin3 />
        },
        {
            path: '/reset-password',
            element: <ResetPasswordForm />
        },
        {
            path: '/changePassword',
            element: <ChangePasswordForm />
        },
        {
            path: '/otp-verification',
            element: <OtpVerification />
        },
        {
            path: '*',
            element: <AuthLogin3 />
        }
    ]
};

export default AuthenticationRoutes;
